<template>
  <transition :name="!scrollUp ? 'secondBar' : 'secondBar-to-up'">
    <div v-show="isActive" class="wrapper-bar-2 absolute-block">
      <img class="bg-img" :src="require('@/assets/lifestyle-page/1.png')" />
      <div class="grid">
        <router-link
          :to="
            $i18nRoute({
              name: 'NewsDetail',
              params: { slug: item.url }
            })
          "
          v-for="(item, index) in list"
          :key="item.id"
          class="grid__item"
        >
          <div class="card" :class="`card-${index + 1}`">
            <div class="card__img">
              <div class="card__category">
                {{ item.sub_category.name }}
              </div>
              <ImageContainer
                class="img"
                :src="item.image.medium"
                :thumb="item.image.thumbnail"
                :alt="item.title"
              />
            </div>
            <div class="card__descr">
              <div class="card__title limited-text">{{ item.title }}</div>
              <div class="data-news">
                <span class="day">{{ handleDate(item.pub_date) }},</span>
                <span class="time">{{ handleTime(item.pub_date) }}</span>
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </transition>
</template>

<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";

export default {
  components: { ImageContainer },
  props: {
    list: {
      type: Array,
      required: true
    },
    isActive: {
      type: Boolean,
      required: true
    },
    scrollUp: {
      type: Boolean,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
.scale-paper {
  transform: scale(3);
}
.wrapper-bar-2 {
  position: relative;
  z-index: 2;
  .bg-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: transparent;
    object-fit: cover;
    z-index: 0;
    transition: all 1s;
  }
  .grid {
    position: relative;
    z-index: 1;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: repeat(6, 1fr);
    width: 80%;
    height: 90%;
    padding-top: 10rem;
    margin: 0 auto;
    color: #121212;
    &__item:nth-child(1),
    &__item:nth-child(2),
    &__item:nth-child(3) {
      grid-column: 1 / span 4;
    }
    &__item:nth-child(4),
    &__item:nth-child(5) {
      grid-column: 9 / span 4;
    }
    &__item:nth-child(1) {
      grid-row: 1 / span 2;
    }
    &__item:nth-child(2) {
      grid-row: 3 / span 2;
    }
    &__item:nth-child(3) {
      grid-row: 5 / span 2;
    }

    &__item:nth-child(4) {
      width: 70%;
      grid-row: 1 / span 3;
    }
    &__item:nth-child(5) {
      width: 70%;
      grid-row: 4 / span 3;
    }
  }
}
.card {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  &__img {
    flex: 0 0 40%;
    .img {
      padding-bottom: 70%;
    }
  }
}
.card-5,
.card-4 {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin: 0 auto;
  width: 90%;
  &__img {
    max-width: 100%;
    flex: 1;
    .img {
      padding-bottom: 0;
    }
  }
  &__descr {
    flex: 1;
  }
}
.card-1,
.card-2,
.card-3 {
  width: 110%;
}
@media screen and (max-width: 1400px) {
  .wrapper-bar-2 {
    padding-top: 0rem;
    .grid {
      margin: auto auto;
      height: 95%;
      width: 95% !important;
      &__item:nth-child(1),
      &__item:nth-child(2),
      &__item:nth-child(3) {
        grid-column: 1 / span 4;
      }
      &__item:nth-child(4),
      &__item:nth-child(5) {
        width: 100%;
        grid-column: 10 / span 3;
      }
    }
    .card {
      width: 105%;
      .card__img {
        flex: 0 0 50%;
      }
    }
  }
}
/* ----------- iPad Pro ----------- */
/* Portrait */
@media only screen and (min-width: 1024px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
  .grid {
    width: 100% !important;
    &__item:nth-child(1),
    &__item:nth-child(2),
    &__item:nth-child(3) {
      grid-column: 1 / span 3 !important;
    }
    &__item:nth-child(1) {
      grid-row: 1 / span 3;
    }
    &__item:nth-child(2) {
      grid-row: 4 / span 3 !important;
    }
    &__item:nth-child(3) {
      grid-column: 5 / span 4 !important;
      grid-row: 5 / span 2 !important;
    }
  }
  .card {
    flex-direction: column;
    align-items: stretch;
    width: 100% !important;
    &__img {
      max-width: 100%;
      flex: 1;
      .img {
        padding-bottom: 70%;
      }
    }
    &__descr {
      flex: 1;
    }
  }
}

.secondBar-to-up-leave-active,
.secondBar-enter-active {
  transition: all 0.6s;
}

.secondBar-enter-from {
  transform: translateY(100%);
}

.secondBar-to-up-leave-to {
  transform: translateY(100%);
}

.secondBar-enter-active,
.secondBar-leave-active {
  transition: all 0.6s;
}

.secondBar-enter-to {
  transform: translateY(0%);
}

.secondBar-to-up-enter-active {
  transition: all 0.6s;
}
.secondBar-leave-to,
.secondBar-to-up-enter-from {
  transform: scale(10);
}

.paper-enter-active,
.paper-leave-active {
  transition: all 1;
}

.paper-leave-to {
  animation: scalePaper 1s;
}

.paper-enter-active,
.paper-leave-active {
  transition: all 1s;
}

.paper-reverse-enter-active,
.paper-reverse-leave-active {
  transition: all 0.6s;
}

.paper-reverse-enter-from {
  opacity: 0;
}

.paper-reverse-enter-to {
  opacity: 1;
  transform-origin: 30% 60%;
  animation: scalePaper 0.6s;
  animation-direction: reverse;
}

.card0-leave-active,
.card0-enter-active,
.card1-leave-active,
.card1-enter-active,
.card4-leave-active,
.card4-enter-active,
.card5-leave-active,
.card5-enter-active,
.card2-enter-active,
.card2-leave-active {
  transition: all 1.2s;
}
.card0-reverse-leave-active,
.card0-reverse-enter-active,
.card1-reverse-leave-active,
.card1-reverse-enter-active,
.card4-reverse-leave-active,
.card4-reverse-enter-active,
.card2-reverse-enter-active,
.card2-reverse-leave-active {
  transition: all 0.8s;
}

.card3-enter-active,
.card3-leave-active {
  transition: all 0.6s;
}
.card3-leave-to {
  transform: translate(-80%, 150%);
}
.card0-leave-to {
  transform: translate(400%, -80%) rotate(-26.2deg) scale(1.9);
}
.card1-leave-to,
.card2-leave-to {
  transform: translateX(-500%);
}
.card4-leave-to {
  transform: translate(500%, 180%) scale(2);
}

.card3-reverse-leave-active,
.card3-reverse-enter-active {
  transition: all 0.6s ease-in;
}
.card3-reverse-enter-from {
  transform: translate(-100%, 150%);
}
.card0-reverse-enter-from {
  transform: translate(400%, -80%) rotate(-26.2deg) scale(1.9);
}
.card1-reverse-enter-from,
.card2-reverse-enter-from {
  transform: translateX(-500%);
}
.card4-reverse-enter-from {
  transform: translate(500%, 180%) scale(2);
}
</style>
<style lang="scss">
@keyframes scalePaper {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(4) translateX(-6%);
  }
}
@keyframes staticPage {
  0% {
    transform: translate(0);
  }
  50% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    transform: translate(0);
    opacity: 0;
  }
}
</style>
